import { Position } from '../interfaces/Position';

export const isValidPosition = (position?: Position | null): boolean => {
  return Boolean(position && position?.latitude && position?.longitude && position?.label);
};
